import {AfterViewInit, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {ScrollbarService } from '../services/scrollbar.service';
import { WindowService} from '../services/window.service';
export class ManageVisibility implements OnInit, AfterViewInit, OnDestroy {
  eivVisible: boolean;
  offsetTop: number;
  ngUnsubscribe = new Subject<void>();
/**
 * @param {?} el
 * @param {?} scroll
 * @param {?} window
 */
constructor(public el: ElementRef,
public scroll: ScrollbarService,
public window: WindowService) { }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.eivVisible = false;
    this.offsetTop = this.scroll.getElOffsetTop(this.el);
  }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
    this.manageVisibility();

    this.scroll.scrollObs.takeUntil(this.ngUnsubscribe)
      .subscribe(() => this.manageVisibility());

    this.window.resizeObs.takeUntil(this.ngUnsubscribe)
      .subscribe(() => this.manageVisibility());
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
/**
 * check for visibility of element
 * @return {?}
 */
manageVisibility(): void {

  }

}

function ManageVisibility_tsickle_Closure_declarations() {
/** @type {?} */
ManageVisibility.prototype.eivVisible;
/** @type {?} */
ManageVisibility.prototype.offsetTop;
/** @type {?} */
ManageVisibility.prototype.ngUnsubscribe;
/** @type {?} */
ManageVisibility.prototype.el;
/** @type {?} */
ManageVisibility.prototype.scroll;
/** @type {?} */
ManageVisibility.prototype.window;
}

